import React from 'react';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';
import {kickUser, showUpdateCompleteLoadingScreen} from '../softwareUpdaterBusiness';
import {showLoading} from '../../actions/appStateAction';
import {SignalREvent, SignalRHub} from '../../../constants/dataEnum';
import {fastStopHubPromise} from '../../../lib/fastSignalRHelper';

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  hubObject.on(SignalREvent.SOFTWARE_UPDATE_PROGRESS, (args) => {
    console.info('event received:', SignalREvent.SOFTWARE_UPDATE_PROGRESS);
    console.log(SignalREvent.SOFTWARE_UPDATE_PROGRESS, args);

    const {progress, userId: executorUserId} = args;

    const {sessionState} = getState();
    const {user} = sessionState;
    const {userId} = user;

    if (executorUserId !== userId) {
      return;
    }

    dispatch(
      showLoading(<FormattedHTMLMessage id="about.updaterLoading.updating.text" values={{percentage: progress}} />),
    );

    if (progress === 100) {
      dispatch(showUpdateCompleteLoadingScreen());
    }
  });

  hubObject.on(SignalREvent.PREPARE_SOFTWARE_UPDATE_STARTED, (args) => {
    console.info('event received:', SignalREvent.PREPARE_SOFTWARE_UPDATE_STARTED);
    console.log(SignalREvent.PREPARE_SOFTWARE_UPDATE_STARTED, args);

    dispatch(kickUser(args));
  });

  hubObject.on(SignalREvent.FINALIZE_SOFTWARE_UPDATE, (args) => {
    console.info('event received:', SignalREvent.FINALIZE_SOFTWARE_UPDATE);
    console.log(SignalREvent.FINALIZE_SOFTWARE_UPDATE, args);

    const {sessionState, signalrState} = getState();
    const {user} = sessionState;

    const {userId} = args;

    if (userId === user.userId) {
      return;
    }

    const signalRHub = Object.values(SignalRHub);

    signalRHub.forEach(async (hub) => {
      if (signalrState[hub]) {
        await fastStopHubPromise(signalrState[hub], hub);
      }
    });
  });

  hubObject.on(SignalREvent.DOWNGRADE_SOFTWARE_UPDATE, (args) => {
    console.info('event received:', SignalREvent.DOWNGRADE_SOFTWARE_UPDATE);
    console.log(SignalREvent.DOWNGRADE_SOFTWARE_UPDATE, args);

    dispatch(kickUser(args));
  });
};

export const unsubscribeEvent = (hubObject) => () => {
  hubObject.off(SignalREvent.SOFTWARE_UPDATE_PROGRESS);
  hubObject.off(SignalREvent.PREPARE_SOFTWARE_UPDATE_STARTED);
  hubObject.off(SignalREvent.FINALIZE_SOFTWARE_UPDATE);
  hubObject.off(SignalREvent.DOWNGRADE_SOFTWARE_UPDATE);
};

export default subscribeEvent;
